class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        function init2() {
          theme.productSlider = (function () {
            function sliderProduct(e) {
              const initialTheme = localStorage.getItem('theme') || 'light';
              let sliderContainer = "",
                extraLargeDesktopShow = 4,
                largeDesktopShow = 3,
                tabletShow = 3,
                mobileShow = 2,
                sliderRows = parseInt(e.dataset.sliderRows),
                sliderSpace = parseInt(e.dataset.slideshow),
                sliderGrid = "column",
                sliderLoop = e.dataset.loop;
          
              if (sliderLoop === "true") {
                sliderLoop = true;
              } else {
                sliderLoop = false;
              }
          
              if (sliderRows > 1) {
                sliderGrid = "row";
                sliderLoop = false;
              }
              if (e.dataset.sliderEnable === "true") {
                sliderContainer = e.querySelector(".productSlider");
                extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge);
                largeDesktopShow = parseInt(e.dataset.showLarge);
                tabletShow = parseInt(e.dataset.showTablet);
                mobileShow = parseInt(e.dataset.showMobile);
              }
          
              var swiper = new Swiper(sliderContainer, {
                loop: sliderLoop,
                slidesPerView: mobileShow,
                spaceBetween: 20,
                observer: true,
                observeParents: true,
                grid: {
                  rows: sliderRows,
                  fill: sliderGrid,
                },
                pagination: {
                  el: e.querySelector(".swiper-pagination"),
                  clickable: true,
                },
                navigation: {
                  nextEl: e.querySelector(".product-slider-wrapper .swiper-button-next"),
                  prevEl: e.querySelector(".product-slider-wrapper .swiper-button-prev"),
                },
                breakpoints: {
                  0: {
                    slidesPerView: 1,
                  },
                  600: {
                    slidesPerView: mobileShow,
                  },
                  768: {
                    slidesPerView: tabletShow,
                  },
                  1024: {
                    slidesPerView: largeDesktopShow,
                  },
                  1280: {
                    slidesPerView: extraLargeDesktopShow,
                  },
                },
              });
            }
            return sliderProduct;
          })();
          
          document.addEventListener("DOMContentLoaded", function () {
            let sections = new theme.Sections();
            sections.register("product-slider", theme.productSlider);
          });
        }
        
        function initSwiper() {
          const initialTheme = localStorage.getItem('theme') || 'light';
          let  extraLargeDesktopShow = parseInt(document.querySelector('.product-recommendations-data').dataset.showExtraLarge);
          let  largeDesktopShow = parseInt(document.querySelector('.product-recommendations-data').dataset.showLarge);
          let  tabletShow = parseInt(document.querySelector('.product-recommendations-data').dataset.showTablet);
          let  mobileShow = parseInt(document.querySelector('.product-recommendations-data').dataset.showMobile);

          var swiper =  new Swiper(".productSlider", {
            slidesPerView: 1,
            loop: false, 
            spaceBetween: 20,
            navigation: {
                clickable:true,
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",   
            },
            pagination: {
                el: ".swiper-pagination-slider",
                clickable:true,
              },
            breakpoints: {
              0: {
                slidesPerView: 1,
              },
              600: {
                slidesPerView: mobileShow,
              },
              768: {
                slidesPerView: tabletShow,
              },
              1024: {
                slidesPerView: largeDesktopShow,
              },
              1280: {
                slidesPerView: extraLargeDesktopShow,
              },
            },
          });
        }

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            // init2();
            initSwiper();
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[recommendation-product]');
           
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[recommendation-product]').innerHTML = recommendations.innerHTML;
            }
            
            
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
}

customElements.define('product-recommendations', ProductRecommendations);